import { Component } from '@angular/core';
import { MbDialogHeader, MbDialogBody, MbIcon } from '@am/moebius';

@Component({
  selector: 'am-payment-method-modal',
  standalone: true,
  templateUrl: './payment-method-modal.component.html',
  styleUrls: ['./payment-method-modal.component.scss'],
  imports: [MbDialogHeader, MbDialogBody, MbIcon],
})
export class PaymentMethodModalComponent {
  constructor() {}
}
